let config = {
  api: process.env.INTERFACE_API,
  apiM: process.env.WE_INTERFACE_API,
  apiWe: process.env.WE_INTERFACE_API,
  apiRoute: process.env.ROUTE_API,
  categories: {
    TT: 'TravelTime',
    CW: 'CityWalks',
    ST: 'SideTours',
    CE: 'CityEncounter'
  },
  categoriesCN: {
    TT: '旅行时光',
    CW: '城市行走',
    ST: '边际旅程',
    CE: '城市奇遇'
  },
  areas: [
    {
      name: '上海',
      sub: [
        '虹口区',
        '徐汇区',
        '静安区',
        '黄浦区',
        '长宁区'
      ]
    },
    {
      name: '南京',
      sub: [
        '浦口区',
        '玄武区',
        '鼓楼区',
        '建邺区'
      ]
    },
    {
      name: '苏州',
      sub: [
        '平江区'
      ]
    }
  ],
  tripStatus: {
    1: '马上报名',
    2: '已取消',
    5: '正在出队',
    6: '截止报名'
  }
}

export default config



/** WEBPACK FOOTER **
 ** ./src/libs/config.js
 **/